/* tslint:disable */
/* eslint-disable */
/**
 * UI schemas for iDeed ARCGx v2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * An enumeration of the contract model types
 * @export
 */
export const ContractType = {
    TriContract: 'TriContract',
    TriContractPaperRecord: 'TriContractPaperRecord'
} as const;
export type ContractType = typeof ContractType[keyof typeof ContractType];


export function ContractTypeFromJSON(json: any): ContractType {
    return ContractTypeFromJSONTyped(json, false);
}

export function ContractTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractType {
    return json as ContractType;
}

export function ContractTypeToJSON(value?: ContractType | null): any {
    return value as any;
}

